import { Level } from './level';
import { LogHandler } from './log-handler';
export class ConsoleHandler extends LogHandler {
  constructor(options = {}) {
    super();
    this.options = options;
  }
  publish(record) {
    if (!this.isLoggable(record)) {
      return;
    }
    const loggingFn = record.level === Level.ERROR ? console.error : console.log;
    const prefix = this.options.useColor ? ['%c[%s]', `color: ${this.options.useColor};`, record.loggerName] : [`[${record.loggerName}]`];
    loggingFn(...prefix, ...record.messages);
  }
}